// Pushes add_to_cart / remove_from_cart events to the dataLayer from the
// cart page AND the cart drawer (both share the same FoxTheme markup):
//   - plus button  -> add_to_cart (qty 1)
//   - minus button -> remove_from_cart (qty 1)
//   - remove link  -> remove_from_cart (current line quantity)
//
// Product data is read from the per-line <script type="application/json"
// data-product-data data-variant-id="..."> tags rendered by
// snippet 'datalayer-cart-product-data'. The cart value is read from the
// rendered subtotal so it stays in sync after AJAX updates.
document.addEventListener('DOMContentLoaded', function () {
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function getCartValue() {
    const totalSpan = document.querySelector('.totals__subtotal-value');
    if (!totalSpan) return 0;
    const text = totalSpan.textContent.trim();
    const numericValue = text
      .replace(/[€\s]/g, '')
      .replace('EUR', '')
      .replace(/\./g, '')
      .replace(',', '.');
    return parseFloat(numericValue) || 0;
  }

  function getProductDataByVariantId(variantId) {
    const script = document.querySelector(`[data-product-data][data-variant-id="${variantId}"]`);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function pushEventToDataLayer(type, variantId, quantity) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;

    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const discount = Math.max(0, maxPrice - finalPrice);
    const itemId = productData.sku || variantId;

    const eventData = {
      event: type,
      ecommerce: {
        currency: currency,
        value: getCartValue(),
        items: [
          {
            item_id: itemId,
            item_name: productData.title,
            item_brand: productData.vendor,
            item_category: productData.item_category || '',
            price: finalPrice,
            quantity: quantity || 1,
            discount: discount,
          },
        ],
      },
      page_path: window.location.pathname,
      full_url: window.location.origin + window.location.pathname,
      login_status: window.GTMData.login_status,
      user_id: window.GTMData.user_id,
      is_logged_user: window.GTMData.is_logged_user,
      store_country: window.GTMData.store_country?.toLowerCase(),
      store_language: window.GTMData.store_language
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);
  }

  function variantIdFromWrapper(wrapper) {
    if (!wrapper) return null;
    const input = wrapper.querySelector('.quantity__input');
    return (input && input.dataset.quantityVariantId) || null;
  }

  document.body.addEventListener('click', function (e) {
    const plusBtn = e.target.closest('button[name="plus"]');
    const minusBtn = e.target.closest('button[name="minus"]');
    const removeBtn = e.target.closest('a[is="cart-remove-item"], a.btn-remove, cart-remove-button a');

    if (plusBtn) {
      const wrapper = plusBtn.closest('quantity-input') || plusBtn.closest('.cart-item');
      const variantId = variantIdFromWrapper(wrapper);
      if (variantId) pushEventToDataLayer('add_to_cart', variantId, 1);
      return;
    }

    if (minusBtn) {
      const wrapper = minusBtn.closest('quantity-input') || minusBtn.closest('.cart-item');
      const variantId = variantIdFromWrapper(wrapper);
      if (variantId) pushEventToDataLayer('remove_from_cart', variantId, 1);
      return;
    }

    if (removeBtn) {
      const wrapper = removeBtn.closest('.cart-item');
      const input = wrapper && wrapper.querySelector('.quantity__input');
      const variantId = (input && input.dataset.quantityVariantId) || null;
      let quantity = 1;
      if (input && input.value) quantity = parseInt(input.value, 10) || 1;
      if (variantId) pushEventToDataLayer('remove_from_cart', variantId, quantity);
    }
  });
});
